import { createSlice } from "@reduxjs/toolkit";

export interface SystemReducerState {
  internalServerError?: boolean;
}

const initialState: SystemReducerState = {
  internalServerError: false,
};

export const systemSlice = createSlice({
  name: "System",
  initialState,
  reducers: {
    showInternalServerError: (state) => {
      state.internalServerError = true;
    },
    reset: (state) => {
      state.internalServerError = undefined;
    },
  },
});
